import React, { useEffect, useRef } from "react";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import {
	Navigation,
	Pagination,
	Scrollbar,
	A11y,
	Autoplay,
	EffectFade,
	EffectCoverflow,
	EffectFlip,
	EffectCube,
	EffectCreative,
	FreeMode,
} from "swiper";
import { ScrollbarOptions, PaginationOptions } from "../Component.type";
import { Avatar, Button, Card, Col, Empty, Row, Skeleton, Space } from "antd";
import styles from "../../Comment.module.css";
import SlidePrevButton from "./SlidePrevButton";
import SlideNextButton from "./SlideNextButton";
import "./CommentSwiperCss.css";
import ResultErrors from "templates/ResultErrors";
import { ConverErrorFetch } from "features/comment/types/comment.type";
import { FreeModeOptions } from "swiper/types";
type breakpoints = {
	xxs: s;
	xs: s;
	sm: s;
	md: s;
	lg: s;
	xl: s;
};
type s = {
	spaceBetween: number;
	slidesPerView: number;
};
type responsive<breakpoints> = {
	[Property in keyof breakpoints]: breakpoints[Property];
};
type Props = {
	dataSource: any[];
	itemRender: (item: any, index: number) => React.ReactNode;
	isloading: boolean;
	responsive: responsive<breakpoints>;
	styleWrapper?: React.CSSProperties | undefined;
	spaceBetween?: string | number | undefined;
	slidesPerView?: number | "auto" | undefined;
	navigation?: boolean;
	pagination?: boolean | PaginationOptions | undefined;
	scrollbar?: boolean | ScrollbarOptions | undefined;
	onSwiper?: ((swiper: any) => void) | undefined;
	onSlideChange?: ((swiper: any) => void) | undefined;
	allowSlideNext?: boolean | undefined;
	allowSlidePrev?: boolean | undefined;
	allowTouchMove?: boolean | undefined;
	autoplay?: boolean | { delay: number; disableOnInteraction: boolean };
	loop?: boolean;
	widthAutoSlide?: boolean;
	error?: ConverErrorFetch;
	handleError?: () => void;
	slidesPerGroup?: number;
	styleButton?: React.CSSProperties | undefined;
	styleButton_next?: React.CSSProperties | undefined;
	styleButton_prev?: React.CSSProperties | undefined;
	initialSlide: number;
	classButtonSlide?: string;
	idSwiper?: string;
	setButtonNext?: string;
	setButtonPrev?: string;
	speed?: number | undefined;
	classWrapper?: string;
	freeMode?: boolean | FreeModeOptions | undefined;
};
const CommentSwiper = ({
	dataSource = [],
	itemRender,
	isloading = true,
	error,
	handleError,
	styleWrapper = { width: "100%" },
	spaceBetween = 4,
	slidesPerView = 6,
	navigation = true,
	pagination = false,
	scrollbar = false,
	onSwiper = (swiper) => {
		return;
	},
	onSlideChange = () => console.log("slide change"),
	allowSlideNext = true,
	allowSlidePrev = true,
	allowTouchMove = true,
	loop = false,
	autoplay = {
		delay: 1500,
		disableOnInteraction: false,
	},
	responsive,
	widthAutoSlide = false,
	slidesPerGroup = 1,
	styleButton,
	styleButton_next,
	styleButton_prev,
	initialSlide,
	classButtonSlide,
	idSwiper,
	setButtonNext,
	setButtonPrev,
	speed = 1500,
	classWrapper,
	freeMode,
}: Props) => {
	const { Meta } = Card;

	const swiperRef = useRef<any>();

	const swiper = useSwiper();

	//

	const handleSlideNext = () => {
		if (swiper) {
			swiper.slideNext();
		}
	};
	const handleSlidePrev = () => {
		if (swiper) {
			swiper.slideNext();
		}
	};

	//

	useEffect(() => {
		if (swiperRef.current && swiperRef.current.swiper) {
			swiperRef.current.swiper.slideTo(initialSlide);
		}
	}, [initialSlide]);

	useEffect(() => {
		if (swiper) {
			const buttonPrev = document.getElementById("button_swiper_prev");
			if (buttonPrev) {
				buttonPrev.addEventListener("click", handleSlidePrev);
			}
			const buttonNext = document.getElementById("button_swiper_next");
			if (buttonNext) {
				buttonNext.addEventListener("click", handleSlideNext);
			}
		}
		return () => {
			if (swiper) {
				const buttonNext = document.getElementById("button_swiper_next");
				if (buttonNext) {
					buttonNext.removeEventListener("click", handleSlideNext);
				}
			}
		};
	}, [swiper]);
	return (
		<div
			className={classWrapper}
			id={widthAutoSlide ? "slide_wrapper_wa" : ""}
			style={{ ...styleWrapper }}>
			{error ? (
				<ResultErrors
					error={error && error.errors}
					prefixError="comment:errors"
					// status={erorrFetch?.status}
					statusCode={error && error.status}
					labelExtra="Tải lại !"
					handleExtra={() => {
						handleError && handleError();
					}}></ResultErrors>
			) : isloading ? (
				<Space className={styles.spaceBlock}>
					<Row
						style={{ flexWrap: "nowrap", overflow: "hidden" }}
						gutter={[8, 8]}>
						{Array.from(new Array(6)).map((i, index) => (
							<Col key={index} span={24} sm={6} md={4}>
								<Card style={{ width: "100%" }} loading={isloading}>
									<Skeleton loading={isloading} avatar active />
								</Card>
							</Col>
						))}
					</Row>
				</Space>
			) : dataSource.length <= 0 ? null : (
				<div
					id="slide_react"
					style={{ position: "relative", width: "100%", height: "100%" }}>
					<Swiper
						ref={swiperRef}
						// install Swiper modules
						id={idSwiper}
						modules={[
							Navigation,
							Pagination,
							Scrollbar,
							A11y,
							Autoplay,
							EffectFade,
							EffectCoverflow,
							EffectFlip,
							EffectCoverflow,
							EffectCube,
							EffectCreative,
							FreeMode,
						]}
						effect="slide"
						freeMode={freeMode}
						edgeSwipeDetection={true}
						spaceBetween={spaceBetween}
						slidesPerView={slidesPerView}
						// initialSlide={initialSlide}

						navigation={
							navigation
								? {
										nextEl: setButtonNext ? `.${setButtonNext}` : "",
										prevEl: setButtonPrev ? `.${setButtonPrev}` : "",
										// disabledClass: "disable_hide",
								  }
								: false
						}
						pagination={
							pagination
								? pagination
								: { clickable: false, renderBullet: () => "" }
						}
						scrollbar={
							scrollbar
								? scrollbar
								: { draggable: true, hide: true, enabled: false }
						}
						// pagination={pagination ? pagination : { clickable: false, renderBullet: () => "" }}
						// scrollbar={scrollbar ? scrollbar : { draggable: true, hide: true, enabled: false }}
						onSwiper={onSwiper}
						onSlideChange={onSlideChange}
						allowSlideNext={allowSlideNext}
						allowSlidePrev={allowSlidePrev}
						allowTouchMove={true}
						autoplay={autoplay}
						loop={loop}
						speed={speed}
						slidesPerGroup={slidesPerGroup}
						breakpoints={{
							325: responsive.xxs,
							375: responsive.xs,
							414: responsive.sm,
							768: responsive.md,
							1024: responsive.lg,
							1500: responsive.xl,
						}}>
						{dataSource.map((item: any, index) => {
							return (
								<SwiperSlide key={index}>{itemRender(item, index)}</SwiperSlide>
							);
						})}
					</Swiper>
					{navigation ? (
						<>
							<button
								id="button_swiper_next"
								style={{ ...styleButton, ...styleButton_next }}
								className={`swiper-button-next ${setButtonNext}  ${
									classButtonSlide ? classButtonSlide : ""
								}`}>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									className="icon icon-tabler icon-tabler-chevron-right"
									width="24"
									height="24"
									viewBox="0 0 24 24"
									strokeWidth="1.75"
									stroke="currentColor"
									fill="none"
									strokeLinecap="round"
									strokeLinejoin="round"
									color="#3a393a">
									<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
									<path d="M9 6l6 6l-6 6"></path>
								</svg>
							</button>
							<button
								id="button_swiper_prev"
								style={{ ...styleButton, ...styleButton_prev }}
								className={`swiper-button-prev ${setButtonPrev} ${
									classButtonSlide ? classButtonSlide : ""
								}`}>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									className="icon icon-tabler icon-tabler-chevron-left"
									width="24"
									height="24"
									viewBox="0 0 24 24"
									strokeWidth="1.75"
									stroke="currentColor"
									fill="none"
									strokeLinecap="round"
									strokeLinejoin="round"
									color="#3a393a">
									<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
									<path d="M15 6l-6 6l6 6"></path>
								</svg>
							</button>
						</>
					) : null}
					{/* <SlidePrevButton></SlidePrevButton>
          <SlideNextButton></SlideNextButton> */}
				</div>
			)}
		</div>
	);
};

export default CommentSwiper;
